import type { RouteResource } from '@townsquare/router/routing-types';

// IMPORTANT - spreading resources can invoke getters, cloning will safely duplicate/edit resource
export const safeCloneResource = (
	resource: RouteResource<unknown>,
	amendments: Partial<RouteResource<unknown>> = {},
): RouteResource<unknown> =>
	resource &&
	(Object.defineProperties({} as Partial<RouteResource<unknown>>, {
		...Object.getOwnPropertyDescriptors(resource),
		...Object.getOwnPropertyDescriptors(amendments),
	}) as RouteResource<unknown>);

export const resourceWithCondition = (
	conditionGetter: () => boolean,
	itemTrue: RouteResource<unknown>,
	itemFalse: RouteResource<unknown> = safeCloneResource(itemTrue, {
		getKey: () => 'DEGENERATE_KEY',
		getData: () => null,
		maxAge: Number.MAX_SAFE_INTEGER,
	}),
): RouteResource<unknown> =>
	itemTrue &&
	(Object.defineProperties(
		{},
		Object.fromEntries(
			[...Object.keys(itemTrue), ...Object.keys(itemFalse)]
				.filter((v, i, a) => a.indexOf(v) === i)
				.map(key => [
					key,
					{
						configurable: false,
						enumerable: true,
						get: (): unknown =>
							conditionGetter() ? itemTrue[key as keyof typeof itemTrue] : itemFalse[key as keyof typeof itemFalse],
					},
				]),
		),
	) as RouteResource<unknown>);
